import { render, staticRenderFns } from "./VesselMonitoringSingleBayDeck.vue?vue&type=template&id=8d7defd2&scoped=true"
import script from "./VesselMonitoringSingleBayDeck.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleBayDeck.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSingleBayDeck.vue?vue&type=style&index=0&id=8d7defd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7defd2",
  null
  
)

export default component.exports